import PropTypes from 'prop-types';
// @mui
import {
  Tooltip,
  IconButton,
  Stack,
  MenuItem,
  Typography,
} from '@mui/material';
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { SearchBar } from './search-bar';

export default function JobCandidateToolbar({
  handleSearchCandidate,
  setShowFiltersDialog,
  filters,
  SORT_MAP,
  sortBy,
  setSortBy,
  isShowingFilterResult,
  resetCheckedCandidates,
  isCandidatesLoading,
}) {
  const sortPopover = usePopover();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="end"
      spacing="12px"
      mb="12px"
      px="50px"
    >
      <SearchBar
        onClick={() => resetCheckedCandidates()}
        onChange={handleSearchCandidate}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            handleSearchCandidate(e);
          }
        }}
      />

      <Tooltip title={filters ? '' : 'No candidates found'}>
        <IconButton
          variant="outlined"
          sx={{
            borderColor: theme =>
              isShowingFilterResult && theme.palette.info.main,
          }}
          onClick={() => {
            resetCheckedCandidates();
            if (filters) setShowFiltersDialog(true);
          }}
        >
          <Iconify icon="tabler:adjustments-horizontal" />
        </IconButton>
      </Tooltip>

      <IconButton
        sx={{
          borderColor: theme =>
            (sortPopover.open ||
              SORT_MAP[sortBy].value !== SORT_MAP.NONE.value) &&
            theme.palette.info.main,
          width:
            SORT_MAP[sortBy].value === SORT_MAP.NONE.value ? 'auto' : '100px',
        }}
        onClick={sortPopover.onOpen}
        variant="outlined"
      >
        <Stack direction="row" alignItems="center" spacing="8px">
          <Iconify
            icon={`tabler:${
              SORT_MAP[sortBy].value === SORT_MAP.NONE.value
                ? 'arrows-sort'
                : `arrow-${SORT_MAP[sortBy].arrow}`
            }`}
          />

          {SORT_MAP[sortBy].value !== SORT_MAP.NONE.value && (
            <Typography variant="input">{SORT_MAP[sortBy].label}</Typography>
          )}
        </Stack>
      </IconButton>

      <CustomPopover open={sortPopover.open} onClose={sortPopover.onClose}>
        <Typography
          variant="paragraph"
          fontWeight={600}
          sx={{
            mb: '12px',
          }}
        >
          Sort By
        </Typography>
        {Object.keys(SORT_MAP).map(item => {
          if (
            SORT_MAP[sortBy].value === SORT_MAP.NONE.value &&
            SORT_MAP[item].value === SORT_MAP.NONE.value
          )
            return null;
          return (
            <MenuItem
              key={item}
              onClick={() => {
                setSortBy(item);
                sortPopover.onClose();
              }}
            >
              <Typography variant="input">{SORT_MAP[item].label}</Typography>
            </MenuItem>
          );
        })}
      </CustomPopover>
    </Stack>
  );
}

JobCandidateToolbar.propTypes = {
  handleSearchCandidate: PropTypes.func.isRequired,
  setShowFiltersDialog: PropTypes.func.isRequired,
  filters: PropTypes.string.isRequired,
  SORT_MAP: PropTypes.object.isRequired,
  sortBy: PropTypes.string.isRequired,
  setSortBy: PropTypes.func.isRequired,
  isShowingFilterResult: PropTypes.bool.isRequired,
  resetCheckedCandidates: PropTypes.func.isRequired,
  isCandidatesLoading: PropTypes.bool.isRequired,
};
